import script from "./UniversalSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./UniversalSearch.vue?vue&type=script&setup=true&lang=js"

import "./UniversalSearch.vue?vue&type=style&index=0&id=9644731e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9644731e"]])

export default __exports__